import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext, useContext, useState, useMemo, useEffect } from "react";
import { ThemeProvider as MuiThemeProvider, createTheme } from '@mui/material/styles';
import { darkTheme, lightTheme, contrastTheme } from "../layouts/Theme";
import { Box } from "@mui/material";
const initialState = {
    setColorMode: (mode) => { },
    defaultMode: "default",
    hasTheme: true,
    light: lightTheme,
    dark: darkTheme,
    contrast: contrastTheme
};
export const ThemeContext = createContext(initialState);
export const useTheme = () => {
    return useContext(ThemeContext);
};
const ThemeProvider = ({ children, initial }) => {
    var _a;
    const [theme, setTheme] = useState(Object.assign(Object.assign({}, initialState), initial));
    const [mode, setMode] = useState((_a = theme === null || theme === void 0 ? void 0 : theme.defaultMode) !== null && _a !== void 0 ? _a : 'default');
    useEffect(() => {
        var _a;
        let newTheme = (_a = initial.defaultMode) !== null && _a !== void 0 ? _a : 'default';
        setMode(newTheme);
    }, []);
    const getTheme = (mode) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        let newTheme = lightTheme;
        switch (mode) {
            case 'default':
                const darkMode = (_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, '(prefers-color-scheme:dark)')) === null || _b === void 0 ? void 0 : _b.matches) !== null && _c !== void 0 ? _c : false;
                if (darkMode) {
                    newTheme = darkTheme;
                    if (theme.hasTheme && darkTheme.palette && theme.dark) {
                        Object.assign(darkTheme.palette, (_d = theme === null || theme === void 0 ? void 0 : theme.dark) === null || _d === void 0 ? void 0 : _d.palette);
                    }
                }
                else {
                    newTheme = lightTheme;
                    if (theme.hasTheme && lightTheme.palette && theme.light) {
                        Object.assign(lightTheme.palette, (_e = theme === null || theme === void 0 ? void 0 : theme.light) === null || _e === void 0 ? void 0 : _e.palette);
                    }
                }
                break;
            case 'light':
                newTheme = lightTheme;
                if (theme.hasTheme && lightTheme.palette && theme.light) {
                    Object.assign(lightTheme.palette, (_f = theme === null || theme === void 0 ? void 0 : theme.light) === null || _f === void 0 ? void 0 : _f.palette);
                }
                break;
            case 'dark':
                newTheme = darkTheme;
                if (theme.hasTheme && darkTheme.palette && theme.dark) {
                    Object.assign(darkTheme.palette, (_g = theme === null || theme === void 0 ? void 0 : theme.dark) === null || _g === void 0 ? void 0 : _g.palette);
                }
                break;
            case 'contrast':
                newTheme = contrastTheme;
                if (theme.hasTheme && contrastTheme.palette && theme.contrast) {
                    Object.assign(contrastTheme.palette, (_h = theme === null || theme === void 0 ? void 0 : theme.contrast) === null || _h === void 0 ? void 0 : _h.palette);
                }
                break;
        }
        return createTheme(newTheme);
    };
    const currentTheme = useMemo(() => getTheme(mode), [mode]);
    return (_jsx(ThemeContext.Provider, { value: theme, children: _jsx(MuiThemeProvider, { theme: currentTheme, children: _jsx(Box, { sx: {
                // backgroundColor: currentTheme.palette.background.default 
                }, children: children }) }) }));
};
export default ThemeProvider;
